export default __webpack_public_path__ + "static/media/6icon.9eae3334.svg";